import { v4 as uuidv4 } from 'uuid';
export default function generateKey() {
    return uuidv4().replace(/-/g, '_'); // 使用 “.“ 调用时，方法名不能包含 ”-“
}
